export default "__VITE_ASSET__CnKwvtr9__"